export default __webpack_public_path__ + "static/media/imgLoja05.5d56127d.png";